import { NavLink } from 'react-router-dom'
import Layout from '../components/Layout'
import { outline } from '../components/ContactButtons'

function NotFound() {
  return (
    <Layout title='Page not found'>
      <h1 className='text-2xl font-bold'>Page not found</h1>
      <p className='mt-2 text-sm text-gray-600'>
        The page you are looking for does not exist or has moved.
      </p>
      <NavLink to='/' className={`${outline} mt-6`}>
        view all projects
      </NavLink>
    </Layout>
  )
}

export default NotFound
